import React from 'react';
import { from24To12 } from '../../../../../../../../services/utilities';

export default class ChairComponent extends React.Component {
    renderRow = (obj) => {
        let {appointment, doctor, patient, diagnostic} = obj

        if(!patient)
            return null

        return (
            <tr onClick={() => this.props.details(appointment._id)} key={appointment._id}>
                <td>{patient.name}</td>
                <td>{patient.lastname}</td>
                <td>{diagnostic.name}</td>
                <td>{from24To12(appointment.time)}</td>
                <td>{(appointment.duration + 1)*15} minutos</td>
            </tr>
        );
    }

    render() {
        if(this.props.appointments.length <= 0)
            return <p>No hay citas...</p>

        return (
            <table className="table is-fullwidth is-hoverable">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Apellidos</th>
                        <th>Servicio</th>
                        <th>Hora</th>
                        <th>Duración</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.appointments.map(this.renderRow)}
                </tbody>
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/pick-day/components/chair/index.js